import { render, staticRenderFns } from "./VerificationMain.vue?vue&type=template&id=ac09a040&scoped=true&"
import script from "./VerificationMain.vue?vue&type=script&lang=js&"
export * from "./VerificationMain.vue?vue&type=script&lang=js&"
import style0 from "./VerificationMain.vue?vue&type=style&index=0&id=ac09a040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac09a040",
  null
  
)

export default component.exports